import { FC } from 'react';
import cx from 'classnames';
import { ZeroWidthSpace } from './ZeroWidthSpace';
import styles from './Skeleton.module.scss';

export interface SkeletonProps {
  className?: string;
  count?: number;
  /** max-width property */
  width?: string;
}

export const Skeleton: FC<SkeletonProps> = ({ className, count = 1, width, ...props }) => (
  <>
    {Array(count)
      .fill(null)
      .map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <ZeroWidthSpace {...props} className={cx(className, styles.skeleton)} key={i} style={width ? { maxWidth: width } : undefined} />
      ))}
  </>
);
